import React, { FC } from 'react';
import { Col as AntdCol } from 'antd';
import { ColProps } from 'antd/lib/grid';

export const Col: FC<ColProps> = (props) => {
  return <AntdCol {...props} />;
};
export default Col;
